/*
 * @Author: M.D.
 * @Date: 2020-01-08 10:49:35
 * @LastEditors: M.D.
 * @Description:
 * @Remarks:
 */
import API from '@/api/api'
const install = (Vue, options) => {
  Vue.prototype.tImgUrl = function (url) {
    // return `http://182.150.59.121:9011/${url}`
    //return `${process.env.VUE_APP_BASE_API}${url}`
    return `${process.env.VUE_APP_BASE_API}${url}`
  }

  // Vue.prototype.uploadImgUrl = `http://182.150.59.121:9011/sys/file/upload`
  Vue.prototype.uploadImgUrl = `${process.env.VUE_APP_BASE_API}sys/file/upload`

  Vue.prototype.handleImgStrArr = function (str) {
    if (str) {
      const imgArr = str.split(',')
      // return imgArr.map(i => `http://182.150.59.121:9011/${i}`)
      return imgArr.map(i => `${process.env.VUE_APP_BASE_API}${i}`)
    }
  }
  // Vue.prototype.errImgDefault = "this.src='https://picsum.photos/800/600'"
  Vue.prototype.errImgDefault = `this.src="${require('@/assets/image/default_img.jpg')}"`
  // v-if= "item.discountPrice !== -1"
  // getFinalPrice
  Vue.prototype.getFinalPrice = item => item.discountPrice === -1 ? item.price : item.discountPrice

  Vue.prototype.getValidPrice = price => {
    price = Number(price)
    return price.toFixed(2)
  }

  Vue.prototype.transformParams = (usrInf, gInf, subInf, finalFee) => {
    const re = {
      memberId: usrInf.id,
      goodsId: gInf.id,
      isVipTimesExchange: subInf.isVipTimesExchange,
      isApplyInvoice: 1, // 是否已开发票  0是 1否 2开具中
      // 3
      gainPoint: (gInf.data && gInf.data.obtailPoint) || '',
      // isOnLinePay: 0-线上支付 1-线下支付，isVipTimesExchange 0-会员免费次数兑换 1-否
      // 如果用会员免费次数下单，则自动认为是线上支付
      isOnLinePay: (subInf.isVipTimesExchange === 0) ? 0 : (gInf.isOnPay - 1),
      number: subInf.gdsNum,
      fee: finalFee,
      // fee: (gInf.discountPrice === -1 ? gInf.price : gInf.discountPrice) * subInf.gdsNum,
      price: gInf.price,
      referralCode: subInf.referralCode,
      receivingMobile: usrInf.receivingMobile,
      receivingAddress: usrInf.receivingAddress,
      receivingName: usrInf.receivingName
    }
    if (gInf.invoiceInfo) {
      re.isApplyInvoice = 2
      for (const key in gInf.invoiceInfo) {
        if (gInf.invoiceInfo.hasOwnProperty(key)) {
          const val = gInf.invoiceInfo[key]
          re[key] = val
        }
      }
      // re.invoiceRise = gInf.invoiceInfo.invoiceRise
      // re.invoiceRiseType = gInf.invoiceInfo.invoiceRiseType
      // re.enterpriseName = gInf.invoiceInfo.enterpriseName
      // re.enterpriseMobile = gInf.invoiceInfo.enterpriseMobile
      // re.enterpriseAddress = gInf.invoiceInfo.enterpriseAddress
      // re.mailbox = gInf.invoiceInfo.mailbox
      // re.bankNumber = gInf.invoiceInfo.bankNumber
      // re.bank = gInf.invoiceInfo.bank
      // re.taxpayerNumber = gInf.invoiceInfo.taxpayerNumber
    }
    re.client = '0'
    // debugger
    return re
  }

  Vue.prototype.eBus = new Vue()

  Vue.prototype.orderVipPrd = async (cityCode, vm) => {
    let vipRes = await API.getVipPrd({
      cityCode: cityCode
    })
    if (vipRes.data.statusCode === '200' && vipRes.data.result) {
      vm.$router.push({
        name: 'productDetail',
        params: {
          prodId: vipRes.data.result
        },
        query: {
          displayFreeQuate: '1'
        }
      })
    } else {
      vm.$message({
        message: vipRes.data.message,
        type: 'warning'
      })
    }
  }

  //Vue.prototype.servicePhone = '(028)62020191'
  // Vue.prototype.servicePhone = '028-62029707'
  Vue.prototype.servicePhone = '028-64698765'
  Vue.prototype.loginPleaseMsg = function () {
    this.$message({
      message: '请先登录',
      type: 'warning'
    })
  }

  Vue.prototype.orderIsOnlinePay = function (isOnlinePay, type) {
    // 积分商品为在线支付
    // isOnLinePay:是否是线上支付 0是 1否
    if (type === 3) {
      return true
    }
    return isOnlinePay === 0
  }

  Vue.prototype.prdIsOnlinePay = function (isOnPay) {
    // isOnPay: 1是在线支付  2是非在线支付商品(面议)
    return Number(isOnPay) === 1
  }

  Vue.prototype.priceDis = function (item, p) {
    // !orderIsOnlinePay(item.isOnLinePay, item.type) ? '价格面议' : `￥${item.fee.toFixed(2)}`
    if (item.isOnLinePay != null && !this.orderIsOnlinePay(item.isOnLinePay, item.type)) {
      return '价格面议'
    }
    p = p || 'fee'
    let pri = (p === 'price') ? item.price : item.fee
    if (item.type === 3) {
      return `${pri}积分`
    }
    return `￥${pri.toFixed(2)}`
  }
  Vue.prototype.timeCounter = function (item, deadCallback, expireCallback) {

  
    let deadline = item.deadline
    // let deadline = '2020/05/14 14:18:00'
    if (!deadline) {
      let el = document.getElementById(item.id)
      if (el) {
        el.innerText = ''
      }
      return
    }

    let timer = setInterval(time, 1000)
    function time () {
      let endTime = new Date(deadline)
      let newTime = new Date()
      let splus = endTime.getTime() - newTime.getTime()

      if (splus < 1) {
        if (splus > -1000) {
          deadCallback && typeof (deadCallback) === 'function' && deadCallback()
        } else {
          expireCallback && typeof (expireCallback) === 'function' && expireCallback()
        }
        clearInterval(timer)
        deadline = null
        timer = null
        return
      }
      let day = Math.floor(splus / 1000 / 60 / 60 / 24)
      let hours = Math.floor(splus / 1000 / 60 / 60 % 24)
      let min = Math.floor(splus / 1000 / 60 % 60)
      let sec = Math.floor(splus / 1000 % 60)
      let el = document.getElementById(item.id)
      if (el) {
        let val = '剩余' + day + '天' + double(hours) + '小时' + double(min) + '分' + double(sec) + '秒'
        el.innerText = val
      }
      function double (n) {
        if (n < 10) {
          n = '0' + n
        }
        return n
      }
    }
  }

  Vue.prototype.btnTimeCounter = function (order, id, name, deadCallback, expireCallback) {
    let deadline = order.deadline
    // let deadline = '2020/05/14 14:18:00'
    if (!deadline) {
      let el = document.getElementById(id + order.id)
      if (el) {
        el.innerText = name
      }
      return
    }

    let btTimer = setInterval(btTime, 1000)
    return btTimer
    function btTime () {
      let endTime = new Date(deadline)
      let newTime = new Date()
      let splus = endTime.getTime() - newTime.getTime()
      if (splus < 1) {
        // let el = document.getElementById(id + order.id)
        // if (el) {
        //   // el.innerText = name
        //   el.style.visibility = 'hidden'
        // }
        if (splus > -1000) {
          deadCallback && typeof (deadCallback) === 'function' && deadCallback()
        } else {
          expireCallback && typeof (expireCallback) === 'function' && expireCallback()
        }
        clearInterval(btTimer)
        deadline = null
        return
      }
      let day = Math.floor(splus / 1000 / 60 / 60 / 24)
      let hours = Math.floor(splus / 1000 / 60 / 60 % 24)
      let min = Math.floor(splus / 1000 / 60 % 60)
      let sec = Math.floor(splus / 1000 % 60)
      let el = document.getElementById(id + order.id)
      if (el) {
        let val = ''
        if (day > 0) {
          val = name + ' ' + day + '天 ' + double(hours) + ':' + double(min) + ':' + double(sec)
        } else {
          val = name + ' ' + double(hours) + ':' + double(min) + ':' + double(sec)
        }
        el.innerText = val
      }

      function double (n) {
        if (n < 10) {
          n = '0' + n
        }
        return n
      }
    }
  }

  Vue.prototype.goodInfo = function (item) {
    if (item.type > 2) {
      return `   `
    }
    // 销量106 | 好评率96%
    let el = ``
    if (item.saleNum != null) {
      el += `销量${item.saleNum}`
    }
    if (item.feedbackRate && item.saleNum) {
      if (item.saleNum) {
        el += ` | `
      }
      el += `好评率${item.feedbackRate * 100}%`
    }
    if (el === '') {
      el = '    '
    }
    return el
  }
}

export default install
